import api from './api';
import { fetchPage } from './pagedParams';

const supplierService = {
    // Get all suppliers for current store
    getSuppliers: async () => {
        const response = await api.get('/admin/suppliers');
        return response.data;
    },

    // Get single supplier
    getSupplierById: async (id) => {
        const response = await api.get(`/admin/suppliers/${id}`);
        return response.data;
    },

    // Create supplier
    createSupplier: async (data) => {
        const response = await api.post('/admin/suppliers', data);
        return response.data;
    },

    // Update supplier
    updateSupplier: async (id, data) => {
        const response = await api.put(`/admin/suppliers/${id}`, data);
        return response.data;
    },

    // Delete supplier
    toggleActive: async (id) => {
        const response = await api.patch(`/admin/suppliers/${id}/toggle-active`);
        return response.data;
    },

    deleteSupplier: async (id) => {
        const response = await api.delete(`/admin/suppliers/${id}`);
        return response.data;
    },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getSuppliersPage: (params) => fetchPage('/admin/suppliers/paged', params),

};

export default supplierService;